import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, LANG_LABELS, resolveDisplayLang } from '@/i18n';
import styles from './LanguageSwitcher.module.css';

/**
 * English / Español / Português. Used in Settings and on the sign-in gate.
 * The marked choice is the language the interface is actually shown in
 * (resolved: `es-MX` marks Español, an unsupported browser language marks
 * English). Choosing calls i18n.changeLanguage, which re-renders at once and,
 * in writable builds, saves the choice to `adia-lang`.
 */
export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = resolveDisplayLang(i18n.resolvedLanguage, i18n.language);

  return (
    <div className={styles.switcher} role="group" aria-label={t('settings.language')}>
      {SUPPORTED_LANGS.map((lang) => (
        <button
          key={lang}
          type="button"
          lang={lang}
          aria-pressed={current === lang}
          className={`${styles.langBtn} ${current === lang ? styles.active : ''}`}
          onClick={() => void i18n.changeLanguage(lang)}
        >
          {LANG_LABELS[lang]}
        </button>
      ))}
    </div>
  );
}
